import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import Button from '@xanadu/ui-shared/components/widgets/Button';

import styles from '../../KycMessaging.module.scss';

const VerificationNeeded = ({
  isDesktop,
  closeModal,
  uploadDocuments,
  redirectToApps,
  showPOIDoc,
  showPOADoc,
}) => (
  <Fragment>
    <div>
      <div className={styles.title}>
        Verification Needed
      </div>
      <div className={styles.bold}>
        {'As per regulatory requirements, all customers must provide the following in date documentation:'}
      </div>
      {(showPOIDoc || showPOADoc) && (
        <ul className={styles.list}>
          {showPOIDoc && <li>Proof of Identity</li>}
          {showPOADoc && <li>Proof of Address</li>}
        </ul>
      )}
      <div>
        <span>{'An email has been sent to your registered email address, outlining the information we require.'}</span>
        <br />
        <br />
        <span>{'If you have submitted the documents already via email, please do not resubmit your documents and await feedback from the Matchbook Compliance team.'}</span>
        <br />
        <br />
        <span>{'Our customer service team is on hand to help with your account via Live Chat.'}</span>
      </div>
    </div>
    <div className={styles.containerActions}>
      <Button
        sizeType="wider"
        buttonType="flat"
        onClick={closeModal}
      >{"I'll do it later"}</Button>
      {isDesktop ? (
        <Button
          sizeType="wider"
          buttonType="primary"
          onClick={uploadDocuments}
          className={styles.primaryButton}
        >Upload Documents</Button>
      ) : (
        <Button
          sizeType="wider"
          buttonType="primary"
          onClick={redirectToApps}
          className={styles.primaryButton}
        >Get the App</Button>
      )}
    </div>
  </Fragment>
);

VerificationNeeded.propTypes = {
  closeModal: PropTypes.func.isRequired,
  uploadDocuments: PropTypes.func.isRequired,
  redirectToApps: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool.isRequired,
  showPOIDoc: PropTypes.bool.isRequired,
  showPOADoc: PropTypes.bool.isRequired,
};

export default VerificationNeeded;

